module.exports = __webpack_public_path__ + "img/三三九_LOGO_320x150.4f637419.png";